import React from "react";
import Styles from './styles.module.scss';

import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

import Seo from "../../components/_UI/seo";

// ---------------------------------------------------------------------------
// Страница для несуществующего адреса. Раньше такой маршрут не был описан, и
// неизвестный URL отдавал пустой экран — ни меню, ни способа вернуться.
//
// Одна страница на обе части сайта: внутри кабинета её показывает
// CabinetLayout со своей шапкой, снаружи — обычный макет с хедером и подвалом.
// Поэтому здесь только содержимое, без собственной навигации.
// ---------------------------------------------------------------------------

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    // из кабинета возвращаем в кабинет, снаружи — на главную
    const isCabinet = location.pathname.startsWith('/cabinet');
    const homePath = isCabinet && authStatus ? '/cabinet' : '/';

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Страница не найдена')}/>

            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.code}`}>404</div>

                <h1 className={`${Styles.title}`}>{t('Страница не найдена')}</h1>

                <div className={`${Styles.note}`}>
                    {t('Возможно, адрес устарел или в нём опечатка. Проверьте ссылку или вернитесь назад.')}
                </div>

                <div className={`${Styles.btnsWrap}`}>
                    <div className={`${Styles.ghostBtn}`} onClick={()=>{navigate(-1)}}>
                        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 1L1 6L6 11M1 6H15" stroke="#FFFFFF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{t('Назад')}</span>
                    </div>

                    <div className={`${Styles.mainBtn}`} onClick={()=>{navigate(homePath)}}>
                        {isCabinet && authStatus ? t('В кабинет') : t('На главную')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NotFoundPage;
